import axios from "axios";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Headmenu from "../sidebar/headmenu";
import Leftsidebar from "../sidebar/leftsidebar";
import LeftResponsivesidebar from "../sidebar/left-responsive";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
const Bcomeseller = () => {
  const route = useNavigate();

  const HandleGEtsellerProfile = async () => {
    try {
      const res = await axios.post(
        `${API_BASE_URL}/seller/get-seller-profile`,
        {}, // empty request body
        {
          headers: {
            token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Seller Profile:", res);
      const result = res?.data?.result;
      if (result?.id) {
        try {
          sessionStorage.setItem("sellerId", String(result.id));
          localStorage.setItem("sellerId", String(result.id));
        } catch (e) {
          console.warn("Unable to persist sellerId to sessionStorage", e);
        }
      }
    } catch (error) {
      console.error("Error fetching seller profile:", error);
    }
  };

  useEffect(() => {
    HandleGEtsellerProfile();
  }, []);
  return (
    <div className="dashboard w-full min-h-screen  flex">
      <Leftsidebar />
      <main className="flex-1 p-6 pl-8">
        <LeftResponsivesidebar />
        <Headmenu />
        <main className="flex">Bcomeseller</main>
      </main>
    </div>
  );
};

export default Bcomeseller;
